import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged } from 'rxjs';

import { MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';

import { ChatThread } from '@lib/chat/models/chat.interface';

import { ChatThreadComponent } from './chat-thread/chat-thread.component';

@Component({
  selector: 'chat-threads-list',
  standalone: true,
  imports: [MatLabel, MatFormField, MatIcon, MatInput, MatPrefix, ReactiveFormsModule, ChatThreadComponent, TranslatePipe],
  templateUrl: './chat-threads-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatThreadsListComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly destroyRef = inject(DestroyRef);

  selectedThread = input.required<ChatThread>();
  threads = input.required<ChatThread[]>();
  unreads = input.required<Map<string, number>>();
  ownUserId = input.required<string>();

  openThread = output<ChatThread>();
  searchOutput = output<string>();
  pinThread = output<string>();
  unpinThread = output<string>();

  protected searchFc: FormControl<string> = this.fb.control<string>(null);

  ngOnInit() {
    this.initThreadsSearch();
  }

  private initThreadsSearch() {
    this.searchFc.valueChanges.pipe(debounceTime(400), distinctUntilChanged(), takeUntilDestroyed(this.destroyRef)).subscribe(value => this.searchOutput.emit(value));
  }

  getUnreadCount(threadId: string) {
    return this.unreads().get(threadId) ?? 0;
  }

  onOpenThread(thread: ChatThread) {
    this.openThread.emit(thread);
  }

  onPinThread(threadId: string) {
    this.pinThread.emit(threadId);
  }

  onUnpinThread(threadId: string) {
    this.unpinThread.emit(threadId);
  }
}
